// extracted by mini-css-extract-plugin
export var active = "_63-7";
export var container = "_63-0";
export var evenWidth = "_63-4";
export var large = "_63-5";
export var outlet = "_63-8";
export var slide = "_63-2";
export var small = "_63-6";
export var tab = "_63-3";
export var tabs = "_63-1";